/** @jsxImportSource @emotion/react */
import React from 'react'
import { SerializedStyles } from '@emotion/react'
import colors from '@sportninja/common/constants/appColors'

interface AccountSettingsIconProps {
  size?: number
  color?: string
  style?: SerializedStyles
}

const AccountSettingsIcon: React.FC<AccountSettingsIconProps> = ({
  size = 24,
  color = colors.PRIMARY,
  style,
}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      height={`${size}px`}
      viewBox='0 -960 960 960'
      width={`${size}px`}
      fill={color}
      css={style}
    >
      <path d='M160-160q-33 0-56.5-23.5T80-240v-480q0-33 23.5-56.5T160-800h640q33 0 56.5 23.5T880-720v480q0 33-23.5 56.5T800-160H160Zm0-320h640v-160H160v160Z' />
    </svg>
  )
}

export default AccountSettingsIcon
